'use client'

import React, { FC, useState } from 'react'
import styles from './Cart.module.css'
import CartRow from './CartRow'
import classNames from 'classnames'
import { useCart } from '../../../contexts/CartContext'
import { getPrice } from '../../../libs/common'
import Button from '../../units/Button/Button'
import { useLaunchParams } from '@telegram-apps/sdk-react'

const Cart: FC = (props) => {
  const cart = useCart()

  const params = useLaunchParams()

  const handleCreateOrder: React.FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault()

    const formData = new FormData(event.target as HTMLFormElement)

    try {
      const res = await fetch(`${process.env.REACT_APP_API_HOST}/api/create-order` as string, {
        method: 'POST',
        body: JSON.stringify({
          order: {
            products: cart.cartProducts,
          },
          user: params.initData?.user,
          address: formData.get('address'),
          phone: formData.get('phone'),
        }),
      })

      const result = await res.json()

      if (result.success === false || !res.ok) {
        alert('Что-то пошло не так. Попробуйте оформить заказ позже')
        return
      }

      alert('Ваш заказ был успешно оформлен. Скоро с вами свяжется наш оператор. Пожалуйста ожидайте.')

      cart.reset()
      handleClose()
    } catch {
      alert('Что-то пошло не так. Проверьте интернет соединение.')
    }
  }

  const handleClose = () => {
    cart.setIsVisibleCart(false)
  }

  const totalPriceWithDiscount = cart.cartProducts.reduce((prev, current) => {
    const price = current.product.cost * current.data.quantity

    return prev + price
  }, 0)

  // let hasDiscount = false
  //
  // const totalPrice = cart.products.reduce((prev, current) => {
  //   const price = current.product.cost * current.data.quantity
  //
  //   return prev + price
  // }, 0)
  const [isVisibleForm, setIsVisibleForm] = useState(false)

  const openForm = () => {
    setIsVisibleForm(true)
  }

  const closeForm = () => {
    setIsVisibleForm(false)
  }

  return (
    <form
      onSubmit={handleCreateOrder}
      className={classNames(styles.cart, { [styles.visible]: cart.isVisibleCart })}
      id="cart"
    >
      <div className={styles.cartHeader}>
        <b>Ваши товары</b>
        <button type="button" className={styles.cartClose} onClick={handleClose} />
      </div>
      {cart.cartProducts.length === 0 ? (
        <>
          <div className={styles.cartEmpty}>Пока-что здесь пусто...</div>
          <div />
        </>
      ) : (
        <>
          <ul>
            {cart.cartProducts.map((cartProduct) => {
              return (
                <CartRow key={cartProduct.data.id} product={cartProduct.product} quantity={cartProduct.data.quantity} />
              )
            })}
          </ul>
          <div className={styles.total}>
            <div className={styles.totalRow}>
              Общая сумма:
              <b>{getPrice(totalPriceWithDiscount)}</b>
            </div>
            <Button type="button" onClick={openForm}>
              Заказать
            </Button>
          </div>
          <div onClick={closeForm} className={classNames(styles.createOrderCover, isVisibleForm && styles.visible)} />
          <div className={classNames(styles.total, styles.createOrder, isVisibleForm && styles.visible)}>
            <button type="button" className={styles.closeCreateOrder} onClick={closeForm} />
            <div className={styles.totalRow}>
              Общая сумма:
              <b>{getPrice(totalPriceWithDiscount)}</b>
            </div>
            <div>
              Укажите ваш номер телефона:
              <br />
              <input type="tel" name="phone" required style={{ width: '100%' }} />
            </div>
            <div>
              Укажите ваш адрес:
              <br />
              <textarea name="address" required style={{ width: '100%' }} />
            </div>
            <Button>Оформить</Button>
          </div>
        </>
      )}
    </form>
  )
}

export default Cart
